<script lang="ts">
	import { onMount } from 'svelte';
	import { getClient, query } from 'svelte-apollo';
	import InterestOverlapTable from '../../components/Overlaps/InterestOverlapTable.svelte';
	import AppContainer from '../../components/AppContainer.svelte';
	import LoadingOverlay from '../../components/LoadingOverlay.svelte';
	import { getInterestOverlapQuery } from '../../graphql/queries/interests';

	const client = getClient();
	const getInterestOverlapOp = query(client, { query: getInterestOverlapQuery });

	function refresh() {
		getInterestOverlapOp.refetch();
	}

	onMount(() => {
		refresh();
	});
</script>

<AppContainer fluid>
	{#await $getInterestOverlapOp}
		<LoadingOverlay title="AI is working..." spinner />
	{:then data}
		<InterestOverlapTable data={data.data.interestOverlap} />
	{:catch e}
		{e}
	{/await}
</AppContainer>

<style>
</style>
